import { useEffect, useState } from "react";
import footerJson from "../data/footer.json";
import SocialMediaIcons from "./SocialMediaIcons";
import { Link } from "react-router-dom";

export default function Footer() {
  const footerData = footerJson;

  const [times, setTimes] = useState({ usa: "", uae: "", pak: "" });

  useEffect(() => {
    const updateTimes = () => {
      setTimes({
        usa: new Date().toLocaleTimeString("en-US", {
          timeZone: "America/New_York",
        }),
        uae: new Date().toLocaleTimeString("en-US", { timeZone: "Asia/Dubai" }),
        pak: new Date().toLocaleTimeString("en-US", {
          timeZone: "Asia/Karachi",
        }),
      });
    };

    updateTimes();
    const interval = setInterval(updateTimes, 1000); // Update every second

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="Footer w-full bg-[#2F2F2F] text-white pt-5 font-open   ">
      <div className="section7-container w-full md:w-[750px] lg:w-[970px] xl:w-[100%] container-1280 mx-auto px-[15px] ">
        <div className="flex flex-col items-center justify-between w-full gap-10 mt-4 mb-10 offices-conatiner offices-section lg:mb-10 lg:mt-10 lg:gap-0 lg:flex-row">
          <div className="flex flex-col items-center gap-4 lg:items-start lg:flex-row ">
            <img src="../../../assets/usatower.png" alt="" className="w-16 h-16" />
            <div className="flex flex-col items-center justify-between h-full gap-4 lg:items-start">
              <h3 className="text-2xl">USA Office</h3>
              <div className="font-bold text-center lg:text-start">
                <p>{times.usa}</p>
                <a href="mailto:info@mean3.com"><p>info@mean3.com</p></a>
                <a href="tel:+1 (832) 278-2928"><p>+1 (832) 278-2928</p></a>
                <a href="https://maps.app.goo.gl/7DjDrshrVA93Ddia6">
                  <p>447 Broadway, 2nd Floor Suite #670, New</p>
                  <p>York 10013, United States</p>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 lg:items-start lg:flex-row ">
            <img src="../../../../assets/burjKhalifa.png" alt="" className="w-16 h-16" />
            <div className="flex flex-col items-center justify-between h-full gap-4 lg:items-start">
              <h3 className="text-2xl">UAE Office</h3>
              <div className="font-bold text-center lg:text-start">
                <p>{times.uae}</p>
                <a href="mailto:info@mean3.com"><p>info@mean3.com</p></a>
                <a href="tel:+971 58 539 9767"><p>+971 (58) 539-9767</p></a>
                <a href="https://maps.app.goo.gl/Qj2AD1KWpiHFJscJ6">
                  <p>IFZA Business Park – Dubai Silicon Oasis –</p>
                  <p>Dubai, United Arab Emirates</p>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 lg:items-start lg:flex-row ">
            <img src="../../../assets/quaid.png" alt="" className="w-16 h-16" />
            <div className="flex flex-col items-center justify-between h-full gap-4 lg:items-start">
              <h3 className="text-2xl">PAK Office</h3>
              <div className="font-bold text-center lg:text-start">
                <p>{times.pak}</p>
                <a href="mailto:info@mean3.com"><p>info@mean3.com</p></a>
                <span><a className="inline-block" href="tel:+923314016473"><p>+92-331-4016473 | </p></a>
                  <a className="inline-block" href="tel:+923343257767"><p> +92-336-6326333</p></a>
                </span>
                <a href="https://maps.app.goo.gl/NDhs3M9DyRch51G46">
                  <p>2nd floor, 48-B Miran Mohammed Shah Rd,</p>
                  <p>Mohammad Ali Society (Machs), Karachi,<br /> Pakistan</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#484848] h-[5px] w-full mt-[15px] mb-5"></div>

        <div className="flex flex-col md:flex-wrap md:flex-row items-start justify-between w-full footer-top gap-y-8">
          <div className="w-full md:px-4 md:w-1/4 ">
            <div className="logo-container h-full flex flex-col justify-around items-center md:items-start gap-10 mb-[30px]">
              <Link to="#">
                <img
                  src="../../../assets/mean3-logo.png"
                  width={125}
                  height={125}
                  alt="Mean3 Logo"
                ></img>
              </Link>
              <p className="text-center text-gray-200 md:text-start">
                We provide all kinds of IT Solutions by constantly pushing
                ourselves and our approach to the edge.
              </p>
            </div>
          </div>

          {footerData.map((item, index) => {
            return (
              <div className="w-full md:px-4 md:w-1/4 links text-center md:text-left" key={index}>
                <h4 className="mt-2 mb-[30px] text-[#d5d5d5] text-lg capitalize hover:text-[#d5d5d5]">
                  {item.title}
                </h4>
                <div>
                  <ul>
                    {item.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link.url}
                          className="block pb-1 capitalize hover:text-[#d5d5d5]"
                        >
                          {link.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}

          <div className="w-full mt-5 md:px-4 md:w-1/4 logos">
            <div className="flex w-full gap-2 mt-2 justify-center md:justify-start">
              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="w-full max-w-[71px] lg:max-w-[100px] text-black bg-white"
                  src="../../../assets/award2.png"
                  alt="Achivements Logos"
                ></img>
              </div>

              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="w-full max-w-[100px] text-black bg-white"
                  src="../../../assets/shopify-experts-logo.png"
                  alt="Achivements Logos"
                ></img>
              </div>
            </div>

            <div className="flex gap-2 mt-2 justify-center md:justify-start">
              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="w-full max-w-[100px] text-black bg-white"
                  src="../../../assets/secp-logo.jpg"
                  alt="Achivements Logos"
                ></img>

              </div>

              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="w-full max-w-[100px] text-black bg-white"
                  src="/assets/go-awards-logo.png"
                  alt="Achivements Logos"
                ></img>
              </div>
            </div>

            <div className="flex gap-2 mt-2 justify-center md:justify-start">
              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="w-full max-w-[100px] text-black bg-white"
                  src="/assets/pasha-logo.jpg"
                  alt="Achivements Logos"
                ></img>
              </div>
              <div className="w-[18%] md:w-[40%] lg:w-[40%]">
                <img
                  className="invisible max-w-[100px] w-full text-black bg-white"
                  // src="../../assets/award2.png"
                  alt="Achivements Logos"
                ></img>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom w-full  md:px-4 text-[13px] ">
          <div className="bg-[#484848] h-[5px] w-full mt-[28px]"></div>
          <div className="flex flex-col-reverse w-full md:justify-between md:flex-row py-3">
            <p className="text-[#8b8c8d] md:mt-0 mt-5">
              © 2025 All rights reserved.{" "}
              <Link className="text-white hover:text-[#d5d5d5]" to="/">
                Mean3
              </Link>
              <span className="text-[#8b8c8d] mx-1">|</span>
              {/* <Link className="text-white hover:text-[#d5d5d5]" to="/privacy-policy">
                Privacy Policy
              </Link> */}
            </p>
            <div className="flex items-center">
              <p className="text-[#8b8c8d] mr-2">GET SOCIAL</p>
              <SocialMediaIcons />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
